// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.setup-step-title {
  color: #0669B3;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.setup-step-directions {
  border: 2px solid #00AEEF;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 1rem;
}
.setup-step-directions p {
  margin-bottom: 0;
}

.setup-selected-students {
  padding: 0 1rem;
  margin-top: 1rem;
  font-size: 1rem;
  color: #333;
}
.setup-selected-students .selected-student-label {
  font-weight: 700;
  margin-right: 6px;
}

.setup-selected-students-divider {
  margin: 1rem 0 0 0;
}

.setup-warning-message {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border: 1px solid #ffc107;
  background-color: #fff8e1;
  border-radius: 4px;
  padding: 12px;
  margin-top: 1.5rem;
}
.setup-warning-message i {
  color: #ff9800;
  font-size: 1.25rem;
  flex-shrink: 0;
  margin-top: 2px;
}
.setup-warning-message span {
  color: #333;
  font-size: 0.95rem;
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SetupDifferentiation.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,cD8BS;EC7BT,gBAAA;EACA,qBAAA;AAKJ;;AAFA;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAKJ;AAHI;EACI,gBAAA;AAKR;;AADA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAIJ;AAFI;EACI,gBAAA;EACA,iBAAA;AAIR;;AAAA;EACI,kBAAA;AAGJ;;AAAA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AAGJ;AADI;EACI,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAGR;AAAI;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;AAER","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n\n.setup-step-title {\n    color: $pearl-blue;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n}\n\n.setup-step-directions {\n    border: 2px solid $information;\n    border-radius: 4px;\n    padding: 12px;\n    margin-bottom: 1rem;\n\n    p {\n        margin-bottom: 0;\n    }\n}\n\n.setup-selected-students {\n    padding: 0 1rem;\n    margin-top: 1rem;\n    font-size: 1rem;\n    color: #333;\n\n    .selected-student-label {\n        font-weight: 700;\n        margin-right: 6px;\n    }\n}\n\n.setup-selected-students-divider {\n    margin: 1rem 0 0 0;\n}\n\n.setup-warning-message {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    border: 1px solid #ffc107;\n    background-color: #fff8e1;\n    border-radius: 4px;\n    padding: 12px;\n    margin-top: 1.5rem;\n\n    i {\n        color: #ff9800;\n        font-size: 1.25rem;\n        flex-shrink: 0;\n        margin-top: 2px;\n    }\n\n    span {\n        color: #333;\n        font-size: 0.95rem;\n        line-height: 1.4;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
